var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"icon":""},on:{"click":_vm.handleClick}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.svg)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }